/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationUtilizationMetricRequest extends models.ScheduleRecommendationDetailsBaseRequest {
    getFixupPrototypeFunction() { return ScheduleRecommendationUtilizationMetricRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationUtilizationMetricRequest>): ScheduleRecommendationUtilizationMetricRequest {
        let obj = Object.assign(new ScheduleRecommendationUtilizationMetricRequest(), model);
        ScheduleRecommendationUtilizationMetricRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationUtilizationMetricRequest>): ScheduleRecommendationUtilizationMetricRequest {
        if (!model) return null;
        return ScheduleRecommendationUtilizationMetricRequest.newInstance(<ScheduleRecommendationUtilizationMetricRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationUtilizationMetricRequest) {
        if (!obj) return;

        models.ScheduleRecommendationUtilizationMetricRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationUtilizationMetricRequest): boolean {
        if (models.ScheduleRecommendationDetailsBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleRecommendationUtilizationMetricRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.elapsed_days === undefined) {
            this.elapsed_days = 0;
        }
    }

    /**
     * Name of the Metric
     */
    metric_name: string;

    /**
     * Number of Days to return Utilization Metrics
     */
    elapsed_days: number;

}
